// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Gq-z","imageAndVideoCount":"Hq-z","imageAndVideoContainer":"Iq-z","viewAllReviews":"Jq-z"};